<form [formGroup]="offerForm" class="select-form">
  <se-fe-form-field [seFeDataConfig]="selectConfig">
    <se-fe-form-field-select
      class="select-form__select"
      formControlName="selectType"
      label="Select Donation Amount"
      seFeDataPlaceholder="Select"
      [seFeDataOptions]="getSelectOptions()"></se-fe-form-field-select>
  </se-fe-form-field>

  @if (showCustomAmount) {
    <se-fe-form-field
      [seFeDataConfig]="customAmountConfig"
      class="select-form__custom-amount">
      <se-fe-form-field-text
        formControlName="customAmount"
        label="Enter amount"
        seFeDataPlaceholder="Enter amount"
        seFeDataType="number"
        seFeDataInputMode="numeric"
        seFeDataAria="Enter amount">
        <se-fe-icon
          seFeFormFieldTextBefore
          seFeDataName="dollar_circle_outline"
          seFeDataSize="600"></se-fe-icon>
      </se-fe-form-field-text>
      <div seFeHelp>Enter any amount greater than $25.00.</div>
    </se-fe-form-field>
  }

  <div class="disclaimer-display">
    <p
      class="disclaimer-display__label"
      [innerHTML]="serviceOffer.disclaimer"></p>
  </div>
</form>
